export default __webpack_public_path__ + "static/media/talkatives.20dec7f8.png";